import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Responses = Record<string, any>;

interface ResponsesState {
  responses: Responses;
  setResponse: (key: string, value: any) => void;
  setResponses: (responses: Responses) => void;
  clearResponses: () => void;
  getResponse: (key: string) => any;
}

export const useResponsesStore = create<ResponsesState>()(
  persist(
    (set, get) => ({
      responses: {},
      setResponse: (key, value) => set((state) => ({
        responses: {
          ...state.responses,
          [key]: value,
        },
      })),
      setResponses: (responses) => set((state) => ({
        responses: {
          ...state.responses,
          ...responses,
        },
      })),
      clearResponses: () => set({ responses: {} }),
      getResponse: (key) => get().responses[key],
    }),
    {
      name: 'assessment-responses',
    }
  )
);
